import { colors } from '../../../../../../../../../constants/colors';

export const classes = {
  icon: {
    color: colors.white,
    opacity: 0.4,
    cursor: 'pointer',
  },
};
